var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExternalLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "noun-share-3492660 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1",
    d: "M1.125 16.875V1.125h9.563a.563.563 0 000-1.125H1.125A1.125 1.125 0 000 1.125v15.75A1.125 1.125 0 001.125 18h15.75A1.125 1.125 0 0018 16.875V7.313a.563.563 0 00-1.125 0v9.563z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2",
    d: "M18 3.938a.563.563 0 01-1.125 0V1.92L9.397 9.4a.566.566 0 11-.8-.8l7.477-7.477h-2.012a.563.563 0 010-1.125h3.375A.562.562 0 0118 .561z",
    fill: "currentColor"
  })));
}

export default __webpack_public_path__ + "fb4a327754716389148d06925bd4256e.svg";
export { SvgExternalLink as ReactComponent };